module.exports = ".background{\r\n\tbackground-color: #081856;\r\n}"